import * as XLSX from 'xlsx';

export function handleDownloadTemplate() {
  const sampleData = [
    {
      'Authority Name': 'MINISTRY OF CORPORATE AFFAIRS (MCA)',
      'Authority Code': 'MCA',
      'Service ID': 'MCA-001',
      'Service Name': 'Name Reservation',
    },
    {
      'Authority Name': 'MINISTRY OF CORPORATE AFFAIRS (MCA)',
      'Authority Code': 'MCA',
      'Service ID': 'MCA-002',
      'Service Name': 'Private Limited Company Incorporation',
    },
    {
      'Authority Name': 'INCOME TAX / CBDT',
      'Authority Code': 'IT',
      'Service ID': 'IT-001',
      'Service Name': 'PAN Application',
    },
  ];

  const worksheet = XLSX.utils.json_to_sheet(sampleData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Authorities');
  XLSX.writeFile(workbook, 'Authority_Services_Template.xlsx');
}
